'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = require('tslib');
var create = require('./create');

/**
 * Create Component
 */
function createComponent(options) {
    var name = options.name, render = options.render;
    return create.create(name, tslib_1.__assign({}, options, render));
}

exports.createComponent = createComponent;
